import { render, staticRenderFns } from "./OrderAddOnsReview.vue?vue&type=template&id=3cf7ddc5&scoped=true&"
import script from "./OrderAddOnsReview.vue?vue&type=script&lang=js&"
export * from "./OrderAddOnsReview.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddOnsReview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderAddOnsReview.vue?vue&type=style&index=1&id=3cf7ddc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7ddc5",
  null
  
)

component.options.__file = "OrderAddOnsReview.vue"
export default component.exports